import React from 'react';
import FormHelperText from '@mui/material/FormHelperText';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';

import DialogTitle from '@mui/material/DialogTitle';
import { ActionButtons } from '../../others/ActionButtons';
import '../../../styles/components/_forms.scss';
import { useTranslation } from 'react-i18next';
export const CreateBranch = ({
    openDialodAddBranch,
    locationForm,
    handleClose,
    handleInputChange,
    handleDirectInputChange,
    handleAddBranch,
    handleChangeCountryState,
    errorInputs,
    countries,
    states,
    cities
}) => {
    const { t } = useTranslation();
    const handleData = (e) => {
        const { name, value } = e.target;
        if (name === 'extension' && value.length > 5) {
            return;
        }
        handleInputChange({ target: { name, value: value.toString() } });
    }

    return (
        <Dialog open={openDialodAddBranch} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>
                {t("client.branchInfo")}
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{ marginTop: "1%" }}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth size="small" error={Boolean(errorInputs.type_office?.isError)} required>
                            <InputLabel>Tipo de Dirección</InputLabel>
                            <Select name="type_office" value={locationForm.type_office} onChange={handleInputChange}>
                                <MenuItem value="Oficina Principal">Oficina Principal</MenuItem>
                                <MenuItem value="Agencia">Agencia</MenuItem>
                                <MenuItem value="Sucursal">Sucursal</MenuItem>
                                <MenuItem value="Tienda">Tienda</MenuItem>
                            </Select>
                            {errorInputs.type_office?.isError && <FormHelperText>{errorInputs.type_office.messageError}</FormHelperText>}
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField fullWidth size="small" name="address" label="Dirección"
                            value={locationForm.address} onChange={handleInputChange}
                            error={Boolean(errorInputs.address?.isError)}
                            helperText={errorInputs.address?.messageError} required
                        />
                    </Grid>

                    <Grid sx={{ flexGrow: 0, flexBasis: '20.83%' }}>
                        <TextField fullWidth size="small" name="phone" label="Teléfono" type="number" className='input-no-spinner'
                            value={locationForm.phone} onChange={handleInputChange}
                        />
                    </Grid>
                    <Grid sx={{ flexGrow: 0, flexBasis: '12.5%' }}>
                        <TextField fullWidth size="small" name="extension" label="Extención" type="number" className='input-no-spinner'
                            value={locationForm.extension} onChange={handleData}
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField fullWidth size="small" name="cellphone" label="Celular" type="number" className='input-no-spinner'
                            value={locationForm.cellphone} onChange={handleInputChange}
                            error={Boolean(errorInputs.cellphone?.isError)}
                            helperText={errorInputs.cellphone?.messageError} required
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField fullWidth size="small" name="email" label="Email"
                            value={locationForm.email} onChange={handleInputChange}
                            error={Boolean(errorInputs.email?.isError)}
                            helperText={errorInputs.email?.messageError} required
                        />
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <FormControl fullWidth size="small" error={Boolean(errorInputs.country?.isError)} required>
                            <InputLabel>País</InputLabel>
                            <Select name="country" value={locationForm.country} onChange={(e) => handleChangeCountryState(e, 'STATE')}>
                                {countries.map((option) => (
                                    <MenuItem key={option.id_country} value={option.code}>{option.name}</MenuItem>
                                ))}
                            </Select>
                            {errorInputs.country?.isError && <FormHelperText>{errorInputs.country.messageError}</FormHelperText>}
                        </FormControl>
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        {locationForm.country === 'CO' ? (
                            <FormControl fullWidth size="small" error={Boolean(errorInputs.state?.isError)} required>
                                <InputLabel>Departamento</InputLabel>
                                <Select name="state" value={locationForm.state} onChange={(e) => handleChangeCountryState(e, 'CITY')}>
                                    {states.map((option) => (
                                        <MenuItem key={option.id_state} value={option.code}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                                {errorInputs.state?.isError && <FormHelperText>{errorInputs.state.messageError}</FormHelperText>}
                            </FormControl>
                        ) : (
                            <TextField fullWidth size="small" name="state" label="Estado"
                                value={locationForm.state} onChange={handleInputChange}
                                error={Boolean(errorInputs.state?.isError)}
                                helperText={errorInputs.state?.messageError || ''} required
                            />
                        )}
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        {locationForm.country === 'CO' ? (
                            <FormControl fullWidth size="small" error={Boolean(errorInputs.city?.isError)} required>
                                <InputLabel>Ciudad</InputLabel>
                                <Select name="city" value={locationForm.city} onChange={handleInputChange}>
                                    {cities.map((option) => (
                                        <MenuItem key={option.code} value={option.code}>{option.name}</MenuItem>
                                    ))}
                                </Select>
                                {errorInputs.city?.isError && <FormHelperText>{errorInputs.city.messageError}</FormHelperText>}
                            </FormControl>
                        ) : (
                            <TextField fullWidth size="small" name="city" label="Ciudad/Localidad"
                                value={locationForm.city} onChange={handleInputChange}
                                error={Boolean(errorInputs.city?.isError)}
                                helperText={errorInputs.city?.messageError || ''} required
                            />
                        )}
                    </Grid>

                    <Grid size={{ xs: 12, md: 4 }}>
                        <TextField fullWidth size="small" name="postal_code" label="Código Postal"
                            value={locationForm.postal_code}
                            onChange={handleInputChange}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <ActionButtons
                    onCancel={handleClose}
                    onSubmit={handleAddBranch}
                // submitLabel={locationForm.edit ? 'Editar' : 'Crear'}
                />
            </DialogActions>
        </Dialog>
    );
};
